import styled from 'styled-components';

import ellipse_1 from '../images/ellipse_1.svg';
import rectangle_4 from '../images/rectangle_4.svg';
import polygon_1 from '../images/polygon_1.svg';
import polygon_2 from '../images/polygon_2.svg';

export const TealCircle = styled.img.attrs({ src: ellipse_1 })`
  position: absolute;
  mix-blend-mode: multiply;
  ${({ styles }) => styles}
`;

export const TealRectangle = styled.img.attrs({ src: rectangle_4 })`
  position: absolute;
  mix-blend-mode: multiply;
  ${({ styles }) => styles}
`;

export const PinkTriangle = styled.img.attrs({ src: polygon_1 })`
  position: absolute;
  mix-blend-mode: multiply;
  ${({ styles }) => styles}
`;

export const TealTriangle = styled.img.attrs({ src: polygon_2 })`
  position: absolute;
  mix-blend-mode: multiply;
  ${({ styles }) => styles}
`;